<div class="nopage-container h-screen flex flex-col justify-center items-center">
  <div class="w-full flex flex-col justify-center items-center">
    <p class="text-6xl">401</p>
    <p class="text-[1.4em]">{{ "nopage.unauthorized_message" | transloco }}</p>
  </div>
  <div class="w-full mt-3 flex justify-center items-center">
    <p-button
      label="{{ 'nopage.buttons.goLogin' | transloco }}"
      [link]="true"
      (click)="goLogin()"
    ></p-button>
  </div>
</div>